module.exports = __webpack_public_path__ + "img/86ba0a8.jpg";